<template>
  <div class="mb-1">
    <div v-if="relations.length > 0" class="resolver">
      <div class="dropdown-container mr-1">
        <drop-down
          id="related-type"
          label="Specify the relationship type"
          :items="relations"
          v-model="relation"
        ></drop-down>
      </div>
      <div>
        <button class="btn btn-primary" type="button" @click="resolveClicked">
          Resolve
        </button>
      </div>
    </div>
    <p v-else>No relationship types available.</p>
  </div>
</template>
<script>
const resolveClicked = function() {
  const args = {
    rel: this.relation,
  };

  this.logDebug("Resolving related sharedos.", {
    arguments: args,
    fieldQueryName: this.query.name,
  });

  this.$emit("resolve", {
    arguments: args,
    fieldQueryName: this.query.name,
  });
};

export default {
  props: {
    field: {
      required: true,
    },
  },
  data: function() {
    return {
      relation: null,
    };
  },
  computed: {
    query: function() {
      return this.field.value.queries.find(
        (q) => q.query.name === "sharedo.related"
      );
    },
    relations: function() {
      if (!!this.query && this.query.query.widgetConfig.options.length > 0) {
        return this.query.query.widgetConfig.options.map((o) => ({
          label: o.name,
          value: o.systemName,
        }));
      }

      return [];
    },
  },
  methods: {
    resolveClicked,
  },
  emits: ["resolve"],
};
</script>
<style lang="scss" scoped>
.resolver {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  & > .dropdown-container {
    flex-grow: 1;
  }
}
</style>
